import React, { useEffect, useState } from "react";
import { Input, Select } from "../../components/forms";
import PhoneInput from "../../components/forms/PhoneInput";
import Button from "../../components/Button";
import InvitedAccepted from "../../components/modal/InviteAccepted";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  acceptResellerInvitation,
  getProviderCategory,
  getProviderProviderContracts,
} from "../../features/user/userSlice";
import { useNavigate } from "react-router-dom";

const ReviewInvitation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [phoneDetails, setPhoneDetails] = useState({});
  const { providerCategory } = useSelector((store) => store.user);
  const invitedUser = localStorage.getItem("inviteData");
  const user = invitedUser ? JSON.parse(invitedUser) : null;
  const [isEditMode, setIsEditMode] = useState(false);
  useEffect(() => {
    if (user?.invitedAccepted) {
      navigate("/review/service");
    }
  }, [navigate, user]);
  const { handleChange, values, setFieldValue, submitForm } = useFormik({
    initialValues: {
      username: "",
      category: "",
    },
    onSubmit: (values) => {
      const payload = {
        phone: phoneDetails?.phoneNumber,
        callingCode: phoneDetails?.country?.dialCode,
        email: user?.data?.email,
        providerName: values.username,
        resellerId: user?.data?.resellerId,
        providerCategoryIds: [values.category],
        token: user?.token,
      };
      dispatch(acceptResellerInvitation(payload)).then((res) => {
        if (res?.type === "user/acceptResellerInvitation/fulfilled") {
          dispatch(getProviderProviderContracts(user?.data?.resellerId)).then(
            (res) => {
              if (res?.type === "user/getProviderProviderContracts/fulfilled") {
                setShowAcceptedModal(true);
              } else {
                setShowAcceptedModal(true);
              }
            }
          );
        }
      });
    },
  });

  useEffect(() => {
    dispatch(getProviderCategory());
  }, []);

  useEffect(() => {
    setFieldValue("username", user?.data?.providerName);
    setFieldValue("category", user?.data?.providerCategories[0]?.id);
  }, []);

  const [showAcceptedModal, setShowAcceptedModal] = useState(false);
  return (
    <div className="max-w-[90%] w-full mx-auto p-[40px]">
      <h1
        className="text-[24px] font-semibold text-center text-[##000B14]
      "
      >
        Review invitation from{" "}
        <span className="text-[#5C6368]">{user?.data?.resellerName}</span>{" "}
      </h1>
      <div className="bg-[#F2F4F7] p-[30px] rounded-xl">
        <Input
          type="text"
          id="username"
          label="Username"
          name="username"
          placeholder="Enter your username"
          className="mb-4"
          value={values.username}
          onChange={handleChange}
          disabled={!isEditMode}
        />
        <div className="clients__phone">
          <div className="phoneInput">
            <PhoneInput setPhoneDetails={setPhoneDetails} />
          </div>
        </div>
        <div>
          <Select
            options={providerCategory.map((category) => ({
              name: category.category,
              value: category.id,
            }))}
            id="category"
            name="category"
            placeholder="Provider Category"
            disabled={!isEditMode}
            value={values.category}
            onChange={handleChange}
          />

          <div className="flex space-x-[30px]">
            {!isEditMode && (
              <Button
                block={true}
                variant="secondary"
                onClick={() => setIsEditMode(true)}
              >
                Edit Details
              </Button>
            )}
            <Button block={true} variant="primary" onClick={submitForm}>
              {isEditMode ? "Save and accept Invite" : "Accept Invite"}
            </Button>
          </div>
        </div>
      </div>
      {showAcceptedModal && (
        <InvitedAccepted
          setShowAcceptedModal={setShowAcceptedModal}
          showAcceptedModal={showAcceptedModal}
        />
      )}
    </div>
  );
};

export default ReviewInvitation;
